export default __webpack_public_path__ + "assets/images/66bd13fb4e12964d22d4ea96b3405201.svg";